import {
    FilterKey,
    FilterType,
    NextAccidentReplacementCarFilterOption,
    NextNNWValueFilterOption,
    NextTerritorialScopeFilterOption,
    NextTowingLimitFilterOption,
    OffersFilter
} from './offers-filter.model';
import {InsuranceCompanyService} from '../../../../../services/insurance-company.service';
import {FiltersDefinitionBase} from './filters-definition-base';

export class NextFiltersDefinition extends FiltersDefinitionBase {
    
    constructor(insuranceCompanyService: InsuranceCompanyService) {
        super(insuranceCompanyService, 'OFFER_SECTION.NEXT_FILTERS.FILTERS');
    }
    
    createConfig(): OffersFilter[] {
        return [
            {
                key: FilterKey.NNW_RANGE,
                title: `${this.translationsContainer}.${FilterKey.NNW_RANGE}.title`,
                type: FilterType.CHECKBOX,
                options: [
                    {
                        key: NextNNWValueFilterOption.UNDER_10,
                        label: `${this.translationsContainer}.${FilterKey.NNW_RANGE}.OPTIONS.${NextNNWValueFilterOption.UNDER_10}`
                    },
                    {
                        key: NextNNWValueFilterOption.ABOVE_10,
                        label: `${this.translationsContainer}.${FilterKey.NNW_RANGE}.OPTIONS.${NextNNWValueFilterOption.ABOVE_10}`
                    }
                ]
            },
            {
                key: FilterKey.TOWING_LIMIT,
                title: `${this.translationsContainer}.${FilterKey.TOWING_LIMIT}.title`,
                type: FilterType.CHECKBOX,
                options: [
                    {
                        key: NextTowingLimitFilterOption.UNDER_150KM,
                        label: `${this.translationsContainer}.${FilterKey.TOWING_LIMIT}.OPTIONS.${NextTowingLimitFilterOption.UNDER_150KM}`
                    },
                    {
                        key: NextTowingLimitFilterOption.FROM_150KM_TO_300KM,
                        label: `${this.translationsContainer}.${FilterKey.TOWING_LIMIT}.OPTIONS.${NextTowingLimitFilterOption.FROM_150KM_TO_300KM}`
                    },
                    {
                        key: NextTowingLimitFilterOption.ABOVE_300KM,
                        label: `${this.translationsContainer}.${FilterKey.TOWING_LIMIT}.OPTIONS.${NextTowingLimitFilterOption.ABOVE_300KM}`
                    }
                ]
            },
            {
                key: FilterKey.TERRITORIAL_SCOPE,
                title: `${this.translationsContainer}.${FilterKey.TERRITORIAL_SCOPE}.title`,
                type: FilterType.CHECKBOX,
                options: [
                    {
                        key: NextTerritorialScopeFilterOption.POLAND,
                        label: `${this.translationsContainer}.${FilterKey.TERRITORIAL_SCOPE}.OPTIONS.${NextTerritorialScopeFilterOption.POLAND}`
                    },
                    {
                        key: NextTerritorialScopeFilterOption.POLAND_EUROPE,
                        label: `${this.translationsContainer}.${FilterKey.TERRITORIAL_SCOPE}.OPTIONS.${NextTerritorialScopeFilterOption.POLAND_EUROPE}`
                    }
                ]
            },
            {
                key: FilterKey.ACCIDENT_REPLACEMENT_CAR,
                title: `${this.translationsContainer}.${FilterKey.ACCIDENT_REPLACEMENT_CAR}.title`,
                type: FilterType.CHECKBOX,
                options: [
                    {
                        key: NextAccidentReplacementCarFilterOption.UNDER_3_DAYS,
                        label: `${this.translationsContainer}.${FilterKey.ACCIDENT_REPLACEMENT_CAR}.OPTIONS.${NextAccidentReplacementCarFilterOption.UNDER_3_DAYS}`
                    },
                    {
                        key: NextAccidentReplacementCarFilterOption.FROM_3_TO_4_DAYS,
                        label: `${this.translationsContainer}.${FilterKey.ACCIDENT_REPLACEMENT_CAR}.OPTIONS.${NextAccidentReplacementCarFilterOption.FROM_3_TO_4_DAYS}`
                    },
                    {
                        key: NextAccidentReplacementCarFilterOption.ABOVE_4_DAYS,
                        label: `${this.translationsContainer}.${FilterKey.ACCIDENT_REPLACEMENT_CAR}.OPTIONS.${NextAccidentReplacementCarFilterOption.ABOVE_4_DAYS}`
                    },
                ]
            },
            {
                key: FilterKey.INSURANCE_COMPANY,
                title: `${this.translationsContainer}.${FilterKey.INSURANCE_COMPANY}.title`,
                type: FilterType.CHECKBOX,
                options: [
                    ...this.createInsuranceCompaniesOptions()
                ],
                initialOptions: []
            },
        ];
    }
}

